import {SET_DATA_YEAR} from './actions';

const DefaultState = {
  dataYear: '2017/2018', //'2015/2016', '2016/2017', '2017/2018'
}

const filters = (state = DefaultState, action) => {
  switch (action.type) {
    case SET_DATA_YEAR:
      
      return Object.assign({}, state, {dataYear: action.data});
    default:
      return state;
  }
}

export {filters}



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/reducer.js